export default {
  "AED": 3.672695,
  "AFN": 66.805,
  "ALL": 127.695574,
  "AMD": 489.181052,
  "ANG": 1.788035,
  "AOA": 165.9075,
  "ARS": 15.4765,
  "AUD": 1.3029,
  "AWG": 1.800506,
  "AZN": 1.79375,
  "BAM": 1.851951,
  "BBD": 2,
  "BDT": 80.274452,
  "BGN": 1.85175,
  "BHD": 0.37701,
  "BIF": 1696.65,
  "BMD": 1,
  "BND": 1.404994,
  "BOB": 6.940966,
  "BRL": 3.110969,
  "BSD": 1,
  "BTC": 0.000877253005,
  "BTN": 66.802468,
  "BWP": 10.398397,
  "BYN": 1.883946,
  "BYR": 20026.25,
  "BZD": 2.018949,
  "CAD": 1.309149,
  "CDF": 1266.025641,
  "CHF": 1.00705,
  "CLF": 0.024272,
  "CLP": 646.8,
  "CNY": 6.865619,
  "COP": 2889.5,
  "CRC": 560.290183,
  "CUC": 1,
  "CUP": 24.728383,
  "CVE": 104.625,
  "CZK": 25.57495,
  "DJF": 178.97,
  "DKK": 7.038856,
  "DOP": 47.2,
  "DZD": 110.36,
  "EEK": 14.79995,
  "EGP": 15.802,
  "ERN": 15.33065,
  "ETB": 22.761151,
  "EUR": 0.946745,
  "FJD": 2.040452,
  "FKP": 0.802375,
  "GBP": 0.802375,
  "GEL": 2.582617,
  "GGP": 0.802375,
  "GHS": 4.575,
  "GIP": 0.802375,
  "GMD": 44.44,
  "GNF": 9440.1,
  "GTQ": 7.384779,
  "GYD": 208.80845,
  "HKD": 7.76095,
  "HNL": 23.63581,
  "HRK": 7.020227,
  "HTG": 67.035705,
  "HUF": 292.13,
  "IDR": 13333.233333,
  "ILS": 3.691965,
  "IMP": 0.802375,
  "INR": 66.645,
  "IQD": 1182.3,
  "IRR": 32421.35754,
  "ISK": 108.861985,
  "JEP": 0.802375,
  "JMD": 129.315655,
  "JOD": 0.7084,
  "JPY": 112.16138542,
  "KES": 103.560312,
  "KGS": 69.106601,
  "KHR": 4046.05,
  "KMF": 464.85,
  "KPW": 900.09,
  "KRW": 1130.4,
  "KWD": 0.30505,
  "KYD": 0.837062,
  "KZT": 312.969606,
  "LAK": 8247.8,
  "LBP": 1516.75,
  "LKR": 151.81,
  "LRD": 94.497383,
  "LSL": 13.005935,
  "LTL": 3.26598,
  "LVL": 0.664776,
  "LYD": 1.436808,
  "MAD": 10.101248,
  "MDL": 19.948214,
  "MGA": 3121.95,
  "MKD": 58.278201,
  "MMK": 1375.65,
  "MNT": 2467.381667,
  "MOP": 8.029479,
  "MRO": 360.979247,
  "MTL": 0.683602,
  "MUR": 35.48,
  "MVR": 15.500347,
  "MWK": 727.458672,
  "MXN": 19.914378,
  "MYR": 4.440006,
  "MZN": 69.5,
  "NAD": 13.005935,
  "NGN": 317,
  "NIO": 29.645,
  "NOK": 8.377315,
  "NPR": 107.075221,
  "NZD": 1.3881,
  "OMR": 0.385178,
  "PAB": 1,
  "PEN": 3.2535,
  "PGK": 3.193007,
  "PHP": 50.169,
  "PKR": 105.290512,
  "PLN": 4.0843,
  "PYG": 5598.2,
  "QAR": 3.6416,
  "RON": 4.277616,
  "RSD": 117.355,
  "RUB": 58.4874,
  "RWF": 841.775,
  "SAR": 3.7506,
  "SBD": 7.778822,
  "SCR": 13.583374,
  "SDG": 6.451498,
  "SEK": 9.038058,
  "SGD": 1.405028,
  "SHP": 0.802375,
  "SLL": 7421.3025,
  "SOS": 580.622404,
  "SRD": 7.5425,
  "STD": 23220.850196,
  "SVC": 8.789016,
  "SYP": 214.343333,
  "SZL": 13.017822,
  "THB": 35.055,
  "TJS": 8.091813,
  "TMT": 3.50998,
  "TND": 2.289513,
  "TOP": 2.24871,
  "TRY": 3.607815,
  "TTD": 6.750137,
  "TWD": 30.652565,
  "TZS": 2235.55,
  "UAH": 27.110824,
  "UGX": 3601,
  "USD": 1,
  "UYU": 28.293384,
  "UZS": 3319.8,
  "VEF": 9.99001,
  "VND": 22799.016667,
  "VUV": 107.467332,
  "WST": 2.5305,
  "XAF": 620.880684,
  "XAG": 0.05395218,
  "XAU": 0.00079547,
  "XCD": 2.70255,
  "XDR": 0.738019,
  "XOF": 621.71465,
  "XPD": 0.00128953,
  "XPF": 113.136737,
  "XPT": 0.00097277,
  "YER": 250.125,
  "ZAR": 12.95248,
  "ZMK": 5253.075255,
  "ZMW": 9.585,
  "ZWL": 322.387247
};



/** WEBPACK FOOTER **
 ** ./src/data/currencies_rates.js
 **/